import React, { useEffect, useState } from "react"
import TextBox from 'devextreme-react/text-box';
import {  RadioGroup, SelectBox, TextArea} from 'devextreme-react';
import { DocumentationRequestTypes, DocumentationRequestWithSubtypes } from "../../../../../Constantes/documentataionRequestTypes";
import CheckBox from 'devextreme-react/check-box';
import { baseRequest } from "../../../../../fetch/basicThunk";
import { QUERY_GET_ITVS_BY_POSTAL_CODE, QUERY_GET_PROVINCE_BY_POSTALCODE } from "../../../../../fetch/constantQueries";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../../../redux/modal/modalSlice";
import { selectDocumentationRequestTemplates, selectDocumentationRequestTemplatesLoading } from "../../../../../redux/documentationRequestTemplates/selectors";
import { getDocumentationRequestTemplates } from "../../../../../redux/documentationRequestTemplates/thunks";
import { deleteStrangeCharacters } from "../../../../../commonFunctions/commonFunctions";
import { getFactoryITVBond } from "../../../../../redux/factoryItvBond/thunks";
import { selectContract } from "../../../../../redux/contract/selectors";
import { selectITVBondInfo } from "../../../../../redux/factoryItvBond/selectors";
import { clearITVBondInfo } from "../../../../../redux/factoryItvBond/factoryITVBondSlice";
import { factoryActive } from "../../../../../Constantes/factoryActive";


function InputWrapper(props){
const {classes, label} = props;
    return(
        <div className="dx-field">
        <label className={classes.label}>{label}</label> 
            <div style={{width:"100%"}} className="dx-field-value">
                {props.children}
            </div>
    </div>
    )
}

function Test2Form(props){
const {classes, onChange, dataForm, onChangeAttachments} = props;
const [stations, setStations] = useState([])
const dispatch = useDispatch();
const types = useSelector(selectDocumentationRequestTemplates);
const typesLoading = useSelector(selectDocumentationRequestTemplatesLoading);
const contract = useSelector(selectContract);
const itvBondInfo = useSelector(selectITVBondInfo);
const zoneTypes=["Madrid","Barcelona","Otros"];
const originalVhTypes =["Itv", "Extranjero", "Zona de seguridad"]
const aafTypes = ["Si", "Junta Extremadura"]
const itvTypes = ["ITV", "ITV SC (Galicia)"]
const costExcemptTypes = ["Sí", "No"]
const producerBookSubtypes = [{name: "No entregado", code: "producer_book_not_given"}, {name: "Extraviado", code: "producer_book_lost"}, {name: "MTR", code: "producer_book_mtr"}];
const accidentRateSubtypes = [{name: "Vh. vigente NO MTR", code: "no_accident_rate_certificate"}, {name: "Vh. vigente MTR", code: "no_accident_rate_certificate_mtr"}, {name: "Vh. baja", code: "no_accident_rate_certificate_inactive"}];
const [mtrSubtypes, setMtrSubtypes ] = useState([{name: "No MTR", code: `${type}`}, {name: "MTR", code: `${type}_mtr`}]);
const [type, setType] = useState(dataForm?.templateCode)


useEffect(()=>{
    dispatch(getDocumentationRequestTemplates())  
},[])

useEffect(()=>{
    if(dataForm?.postalCode && (!stations || stations.length ==0)){
        setProvince();
    }
},[])

useEffect(()=>{
    if(type && types.length > 0){
    onChange("templateId", getTemplateIdFromCode(type))
    if(hasSubtype(type)){
        if(!selectedSubtypeBelongsToType()){
            onChange("subtype", "")
        }
        setMtrSubtypes([{name: "No MTR", code: `${type}`}, {name: "MTR", code: `${type}_mtr`}])
    }
    if(type === DocumentationRequestTypes.ITV_BOND && factoryActive){
        contract?.plate && dispatch(getFactoryITVBond({query: `?plate=${contract.plate}`}));
    }
    else {
        dispatch(clearITVBondInfo());
    }
    }
},[type, types])

async function fetchProvinceFromPostalCode(postalCode){
    let province;
    try {
        province = await baseRequest({param: postalCode }, dispatch, QUERY_GET_PROVINCE_BY_POSTALCODE, "GET");
    } catch (error) {
        province = null
        onChange("province", null)
        setStations([])
    }
    
    return province
}

async function setProvince(){
    if(!dataForm?.postalCode || dataForm?.postalCode.length < 5 ){
        onChange("province", null); 
        onChange("stationId", null);
        return
    }

    const province = await fetchProvinceFromPostalCode(dataForm?.postalCode);
    
    if(province){
        const provinceHasNewValue = province.name !== dataForm?.province
        if(provinceHasNewValue){
            onChange("stationId", null)
        }
        onChange("province", province.name)
        fetchStations(dataForm?.postalCode)
    } else {
        onChange("stationId", null)
    }
}

function setPhoneNumber(e){
    let nonDigitsRegExp = /\D/gm;
    const filteredNumber = e.value.replace(nonDigitsRegExp, "")
    onChange("phoneNumber", filteredNumber)
}

function setNotes(e){
    const filteredText = deleteStrangeCharacters(e.value); 
    onChange("notes", filteredText)
   
}

async function fetchStations(postalCode){

    try {
        const stations = await baseRequest({param: postalCode }, dispatch, QUERY_GET_ITVS_BY_POSTAL_CODE, "GET")
        if(stations){
            setStations(stations)
        }
    } catch (error) {
        dispatch(openModal({type: "error", message: "No se han podido cargar las ITVs"}))
    }
 

}

function getTemplateIdFromCode(code){
    const {id} = types.find(type=> type.code === code)
    return  id
}

function hasSubtype(type){
    const hasSubtype = DocumentationRequestWithSubtypes.some(templateWithSubtypes=> templateWithSubtypes === type) 
    return hasSubtype
}

function selectedSubtypeBelongsToType(){
    const subtypes = getSubtypes(type)
    return subtypes.some(subtype=> subtype.code === dataForm.subtype) 
}

function getSubtypes(type){
    switch(type){
        case DocumentationRequestTypes.ORIGINAL:
            return mtrSubtypes;
        case DocumentationRequestTypes.PRODUCER_BOOK:
            return producerBookSubtypes;
        case DocumentationRequestTypes.NO_ACCIDENT_RATE_CERTIFICATE:
            return accidentRateSubtypes;
        case DocumentationRequestTypes.TELEMATIC_COPY:
            return mtrSubtypes;
        case DocumentationRequestTypes.INVOICE_DUPLICATE:
            return mtrSubtypes;
        case DocumentationRequestTypes.ORIGINAL_DUPLICATE:
            return mtrSubtypes
        default:
            return [];
    }
}

function setItvBondQueryOnly(value){
    if (value === true) {
        onChange("subtype", "itv_bond_query_only");
        onChange ("aaff", null);
    } else {
        if (dataForm.subtype === "itv_bond_query_only"){
            onChange("subtype", null) 
        }
    }
    onChange ("queryOnly", value)
}

function setItvAAFF(value){
    if(!dataForm.queryOnly){
        if (value === "Junta Extremadura"){
            onChange("subtype", "itv_bond_aaff")
        } else {
            if(dataForm.subtype === "itv_bond_aaff"){
                onChange("subtype", null)
            }
        }
    }
    onChange ("aaff", value)
}

    return(
        <div className={classes.containers} id="documentation-request-form">
              <InputWrapper classes={classes} label={"Tipología"}>
                    <SelectBox searchEnabled disabled={typesLoading === "loading"} value={type} onValueChanged={(e) => {setType(e.value); onChange("templateCode", e.value)}} valueExpr={"code"} displayExpr="name" placeholder="" dataSource={types} height={25}></SelectBox>
                </InputWrapper>
            <>
            {hasSubtype(type) && 
                <InputWrapper classes={classes} label={"Diferenciador"}>
                    <SelectBox value={dataForm?.subtype} onValueChanged={(e) => onChange("subtype",e.value)} valueExpr={"code"} displayExpr={"name"} placeholder="" dataSource={getSubtypes(type)} height={25}></SelectBox>
                </InputWrapper>
            }
            {type === DocumentationRequestTypes.ITV_BOND  &&
                <>
                <InputWrapper classes={classes} label={"Solo consulta"}>
                    <CheckBox key={"queryOnly"} name="queryOnly" disabled={!factoryActive} value={dataForm?.queryOnly?dataForm?.queryOnly:false} onValueChanged={(e) => setItvBondQueryOnly(e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>
                    <div className={classes.input_grid}>
                        <InputWrapper classes={classes} label={"Decisión"}>
                            <SelectBox disabled={Boolean(dataForm?.queryOnly)} value={dataForm?.aaff} onValueChanged={(e) => setItvAAFF(e.value)} placeholder="" dataSource={aafTypes} height={25}></SelectBox>
                        </InputWrapper>
                        <InputWrapper classes={classes} label={"Itv"}>
                            <RadioGroup disabled={!factoryActive} items={itvTypes} onValueChanged={(e)=>onChange("itvType",e.value)} value={dataForm?.itvType} layout="horizontal" height={25} style={{marginTop: 0}}/>
                        </InputWrapper>
                    </div> 
                    <div className={classes.input_grid}>
                        <InputWrapper classes={classes} label={"Código postal"}>
                            <TextBox maxLength={5} key={"postalCode"} name="postalCode" value={dataForm?.postalCode} onFocusOut={()=>setProvince()}  onValueChanged={(e) => onChange("postalCode", e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                        <InputWrapper classes={classes} label={"Provincia"}>
                            <TextBox disabled key={"province"} name="province" value={dataForm?.province} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                    </div>
                    <div className={classes.input_grid}>
                        <InputWrapper classes={classes} label={"F. Matriculación"}>
                            <TextBox disabled={!factoryActive} readOnly maxLength={5} key={"registerDate"} name="registerDate" value={itvBondInfo?.registrationDate} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                        <InputWrapper classes={classes} label={"Último bono enviado"}>
                            <TextBox disabled={!factoryActive}  readOnly key={"lastSentBond"} name="lastSentBond" value={itvBondInfo?.lastSentBond} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                    </div>
                    <div className={classes.input_grid}>
                        <InputWrapper classes={classes} label={"F. Ultima ITV"}>
                            <TextBox disabled={!factoryActive}  readOnly maxLength={5} key={"lastITVDate"} name="lastITVDate" value={itvBondInfo?.lastITVDate} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                        <InputWrapper classes={classes} label={"F. Próxima ITV"}>
                            <TextBox disabled={!factoryActive}  readOnly key={"nextITVDate"} name="nextITVDate" value={itvBondInfo?.nextITVDate} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>
                    </div>
                </>      
             }
             {(type === DocumentationRequestTypes.ORIGINAL || type === DocumentationRequestTypes.ORIGINAL_DUPLICATE ||type === DocumentationRequestTypes.ENVIRONMENTAL_STICKER ||type === DocumentationRequestTypes.PRODUCER_BOOK || type === DocumentationRequestTypes.RESIDENT_CARD || type === DocumentationRequestTypes.EUROPEAN_PART ) &&  
                <InputWrapper classes={classes} label={type === DocumentationRequestTypes.ORIGINAL ? "Dirección (incluir CP, Localidad y Provincia)" : "Dirección"}>
                    <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
            }
            <div className={classes.input_grid}>
                <InputWrapper classes={classes} label={"Nombre"}>
                    <TextBox key={"name"} name="name" value={dataForm?.name} onValueChanged={(e) => onChange("name",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"Apellidos"}>
                    <TextBox key={"surname"} name="surname" value={dataForm?.surname} onValueChanged={(e) => onChange("surname",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                </div>
            {(type=== DocumentationRequestTypes.FACTORY_PROCESS_DRIVER_CHANGE || type=== DocumentationRequestTypes.INSURANCE_OTHER || type=== DocumentationRequestTypes.CONECTIVITY || type === DocumentationRequestTypes.ORIGINAL_DUPLICATE || type === DocumentationRequestTypes.ORIGINAL || type === DocumentationRequestTypes.ZERO_EMISION_CERTIFICATE || type === DocumentationRequestTypes.RESIDENT_CARD ) && 
            <InputWrapper classes={classes} label={"DNI"}>
                <TextBox key={"dni"} name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)} className={classes.controlers} height={25}></TextBox>
            </InputWrapper>
            }
            { (type === DocumentationRequestTypes.ENVIRONMENTAL_STICKER || type === DocumentationRequestTypes.PRODUCER_BOOK) &&

                <InputWrapper classes={classes} label={"Móvil"}>
                    <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
            }
            { (type !== DocumentationRequestTypes.ENVIRONMENTAL_STICKER && type !== DocumentationRequestTypes.PRODUCER_BOOK) &&
                <div className={type !== DocumentationRequestTypes.RESIDENT_CARD?classes.input_grid:""}>
                    {type !== DocumentationRequestTypes.RESIDENT_CARD && type !== DocumentationRequestTypes.NO_ACCIDENT_RATE_CERTIFICATE  &&
                        <InputWrapper classes={classes} label={"Móvil"}>
                            <TextBox key={"phoneNumber"} maxLength={9} name="phoneNumber" value={dataForm?.phoneNumber} onValueChanged={(e) =>{setPhoneNumber(e)}} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>      
                    }
                    {type === DocumentationRequestTypes.NO_ACCIDENT_RATE_CERTIFICATE  &&
                        <InputWrapper classes={classes} label={"DNI"}>
                            <TextBox key={"dni"} name="dni" value={dataForm?.dni} onValueChanged={(e) => onChange("dni",e.value)} className={classes.controlers} height={25}></TextBox>
                        </InputWrapper>      
                    }
                    <InputWrapper classes={classes} label={"Correo electrónico"}>
                        <TextBox key={"email"} name="email" value={dataForm?.email} onValueChanged={(e) => onChange("email",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                </div>
            }
            <div className={classes.input_grid}>
            { type === DocumentationRequestTypes.ORIGINAL_DUPLICATE &&
                <InputWrapper classes={classes} label={"Informado costes"}>
                    <CheckBox key={"inform"} name="inform" value={dataForm?.inform?dataForm?.inform:false} onValueChanged={(e) => onChange("inform", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>
            }
            {  type === DocumentationRequestTypes.ORIGINAL &&
                <InputWrapper classes={classes} label={"Tipo"}>
                    <SelectBox value={dataForm?.originalVhDocType} onValueChanged={(e) => onChange("originalVhDocType",e.value)} placeholder="" dataSource={originalVhTypes} height={25}></SelectBox>
                </InputWrapper>
            }
            </div>
            {type === DocumentationRequestTypes.RESIDENT_CARD &&
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label={"MTR"}>
                        <CheckBox key={"mtr"} name="mtr" value={dataForm?.mtr? dataForm.mtr : false} onValueChanged={(e) => onChange("mtr", e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Zona"}>
                        <SelectBox value={dataForm?.zone} onValueChanged={(e) => onChange("zone",e.value)} placeholder="" dataSource={zoneTypes} showClearButton height={25}></SelectBox>
                    </InputWrapper>
                </div>
            }
            {type === DocumentationRequestTypes.ITV_BOND &&
            <>           
                <InputWrapper classes={classes} label={"Estación"}>
                    <SelectBox value={dataForm?.stationId} valueExpr={"id"} 
                        placeholder={""}
                        disabled={!dataForm?.province}
                        searchEnabled
                        onValueChanged={(e) => onChange("stationId",e.value)} 
                        itemRender={(item)=><div className={classes.custom_item}> <span style={{fontWeight: "bold"}}>{item && `${item.city}`}</span>{item? `, ${item?.address ? item.address : ""} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""}</div>}
                        displayExpr={(item)=> item? `${item?.city}, ${item?.address} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""} 
                        dataSource={stations} height={25} 
                        noDataText={"Nenhuma opção disponível"}>
                    </SelectBox>
                </InputWrapper>
            </>
            }
            {
                type === DocumentationRequestTypes.CONECTIVITY &&
                <InputWrapper classes={classes} label={"Nombre accesorio"}>
                    <TextBox key={"accesoryName"} name="accesoryName" value={dataForm?.accesoryName} onValueChanged={(e) => onChange("accesoryName",e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
            }
            {
                type === DocumentationRequestTypes.INSURANCE_DUPLICATE &&
                <InputWrapper classes={classes} label={"Urgente"}>
                    <CheckBox key={"urgent"} name="urgent" value={dataForm?.urgent?dataForm?.urgent:false} onValueChanged={(e) => onChange("urgent",e.value)} className={classes.controlers} height={25} style={{marginTop: 0}}></CheckBox>
                </InputWrapper>
            }
            {
                type === DocumentationRequestTypes.ENVIRONMENTAL_STICKER &&
                <>
                    <InputWrapper classes={classes} label={"Motivo"}>
                        <TextBox key={"reason"} name="reason" value={dataForm?.reason} onValueChanged={(e) => onChange("reason",e.value)} className={classes.controlers} height={25}></TextBox>
                    </InputWrapper>
                    <InputWrapper classes={classes} label={"Informado de costes"}>
                        <SelectBox value={dataForm?.costExcempt} onValueChanged={(e) => onChange("costExcempt",e.value)} placeholder="" dataSource={costExcemptTypes} height={25}></SelectBox>       
                    </InputWrapper>
                </>   
            }
        </>
            <InputWrapper classes={classes} label={"Notas"}>
                <TextArea key={"notes"} name="notes" value={dataForm?.notes} onValueChanged={(e) => setNotes(e)} className={classes.controlers} height={60}></TextArea>
            </InputWrapper>

            <InputWrapper classes={classes} label={"Anexo"}>
                <input type="file" key={"attachments"}  name="attachments" multiple onChange={(e) => onChangeAttachments([...e.target.files])} className={classes.controlers} />
            </InputWrapper>
        </div>
    )
}

export { Test2Form }